// Pure classification of a persisted character-authoring draft against the
// current backend. Extracted from characterAuthoringStore.loadDraftFromLS so
// the stale-backend safety rules (docs/UX_PRINCIPLES.md — never silently merge
// a draft authored against a different API target) are unit-testable without
// a browser. No imports — pure logic only.

// classifyStoredDraft(raw, apiTarget, activeCharId) → one of:
//   { status: 'none' }                              — nothing usable (missing, malformed, corrupted)
//   { status: 'loaded', draft, dirty }              — tagged for THIS backend; safe to hydrate
//   { status: 'stale-backend', draft, authoredAgainst? } — tagged for another backend
//                                                     (or untagged legacy) — hold for Apply/Discard
export function classifyStoredDraft(raw, apiTarget, activeCharId) {
  if (!raw) return { status: 'none' }
  let parsed
  try {
    parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
  } catch {
    return { status: 'none' }
  }
  if (!parsed || typeof parsed !== 'object') return { status: 'none' }

  if ('_authoredAgainst' in parsed) {
    if (parsed._authoredAgainst === apiTarget) {
      const draft = parsed.draft
      // A draft stored under charA's key whose .id is charB is corrupted —
      // refuse to load (defends against pre-v4 legacy data).
      if (draft?.id && activeCharId && draft.id !== activeCharId) {
        return { status: 'none', corrupted: true }
      }
      // Older records lacking _isDirty default to clean (no surprise pill).
      return { status: 'loaded', draft, dirty: !!parsed._isDirty }
    }
    return { status: 'stale-backend', draft: parsed.draft, authoredAgainst: parsed._authoredAgainst }
  }

  // Untagged legacy draft: never silently merge — user decides.
  return { status: 'stale-backend', draft: parsed }
}
